import { Layout, Space } from 'antd';
import NameDropdown from './NameDropdown';
import { Link } from 'react-router-dom';
import LogoApp from '../Logo';
import useAccountNavigate from '../../hooks/useAccountNavigate';

const { Header } = Layout;

export default function AppHeader({ className }) {
  const { accountPath, accountId } = useAccountNavigate();

  return (
    <Header
      style={{
        background: 'white',
        borderBottom: '1px solid #e8e8e8',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', // Add subtle shadow for separation
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 20px',
        height: '60px', // Slightly increase height for better spacing
        position: 'sticky', // Make the header sticky
        top: 0, // Ensure it stays at the top
        zIndex: 1000, // Ensure it stays above other elements
      }}
    >
      <Link
        to={accountId ? accountPath('/home') : '/accounts'}
        style={{
          paddingLeft: 'inherit',
        }}
      >
        <Space align="center" className="select-none">
          <LogoApp width={120} color="black" />
        </Space>
      </Link>
      <NameDropdown />
    </Header>
  );
}
